<div class="clip-tools-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ data.mode === 'PENDING' ? ('ASSORTED.PENDING' | translate) : ('BUTTON.' + data.mode | translate) }}</span>
		<button mat-icon-button (click)="closeDialog()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-4">
    <form [formGroup]="formGroup" >
		<mat-form-field class="w-50 pb-2">
			<mat-label>{{ 'ASSORTED.SELECT_OPTION' | translate }}</mat-label>
			<select id="select-tool" style="display: none"></select>
			<!-- workaround for material-chrome bug -->
			<mat-select id="select-tool" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="tool" (selectionChange)="onSelectTool()">
				@for (value of tools; track $index) {
				<mat-option [value]="value">{{ 'CLIPS.' + value | translate }}</mat-option>
				}
			</mat-select>
		</mat-form-field>

		@if(data.type === 'custom-fields') {
		<div [formGroup]="formGroup" class="d-flex pb-2">
			@for(field of fieldsToDisplay; track field) { @if (field.type === 'date-range') {
			<mat-form-field class="w-50 me-1">
				<mat-date-range-input [formGroup]="dateRangePicker" color="primary" [rangePicker]="picker">
					<input id="dateFrom" formControlName="dateFrom" matStartDate placeholder="Start date" />
					<input id="dateTo" formControlName="dateTo" matEndDate placeholder="End date" />
				</mat-date-range-input>
				<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-date-range-picker #picker>
					<mat-date-range-picker-actions>
						<button mat-button matDateRangePickerCancel>{{ 'BUTTON.CANCEL' | translate }}</button>
						<button mat-raised-button color="primary" matDateRangePickerApply>{{ 'BUTTON.APPLY' | translate }}</button>
					</mat-date-range-picker-actions>
				</mat-date-range-picker>

				@if (dateRangePicker.controls['dateFrom'].hasError('matStartDateInvalid')) {
				<mat-error>Invalid start date</mat-error>
				} @if (dateRangePicker.controls['dateTo'].hasError('matEndDateInvalid')) {
				<mat-error>Invalid end date</mat-error>
				}
			</mat-form-field>
			} @else if (field.type === 'selection-multiple') {
			<mat-form-field>
				<mat-label>{{ 'ASSORTED.SELECT_OPTION' | translate }}</mat-label>
				<select id="selection" style="display: none"></select>
				<!-- workaround for material-chrome bug -->
				<mat-select id="selection" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="source" multiple>
					@for (value of field.value; track $index) {
					<mat-option [value]="value">{{ value }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
			} @else if (field.type === 'medium-selection') {
			<mat-form-field>
				<mat-label for="clip-medium">{{ 'CLIPS.MEDIUM' | translate }}</mat-label>
				<input type="text" matInput formControlName="medium" [matAutocomplete]="mediumAutocomplete" />
				<mat-autocomplete #mediumAutocomplete="matAutocomplete" [displayWith]="displayFn.bind(this)">
					@for (filteredItem of filteredMediums; track $index) {
					<mat-option [value]="filteredItem">{{ utils.getParameterByLanguageScript(filteredItem, 'name') }}</mat-option>
					}
				</mat-autocomplete>
			</mat-form-field>
			} }
		</div>

		@if (hasTagSelection()) {
		<div class="pb-0">
			<div class="custom-dropdown-container" #customDropdownTrigger>
				<mat-form-field class="w-100" (click)="toggleCustomDropdown($event)">
					<mat-label>{{ 'NAVBAR.TAGS' | translate }}</mat-label>
					<input matInput 
						   [value]="getSelectedTagsDisplay()" 
						   readonly>
					<mat-icon matSuffix>{{ customDropdownOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
				</mat-form-field>
			</div>

			<div class="d-flex justify-content-start align-items-center mt-1">
				<div class="button-group">
					<button mat-flat-button class="custom-button select-all me-2" (click)="selectAllTags()">
						<mat-icon class="me-1">select_all</mat-icon>
						{{ 'ASSORTED.SELECT_ALL' | translate }}
					</button>
					<button mat-flat-button class="custom-button unselect-all" (click)="unselectAllTags()">
						<mat-icon class="me-1">deselect</mat-icon>
						{{ 'ASSORTED.UNSELECT_ALL' | translate }}
					</button>
				</div>
			</div>
		</div>
		}
		}
    </form>
	</mat-dialog-content>

	<mat-dialog-actions [align]="'end'">
		<mat-divider class="w-100 my-2"></mat-divider>

		<button mat-flat-button color="warn" (click)="buttonAction(true)" [disabled]="formGroup.invalid">
			{{ 'BUTTON.CONFIRM' | translate }}
		</button>

		<button mat-flat-button color="primary" (click)="closeDialog()">
			{{ 'BUTTON.CANCEL' | translate }}
		</button>
	</mat-dialog-actions>
</div>
